<template>
  <div class="field-group" :class="{ 'has-error': !!error }">
    <div class="field-heading">
      <label v-if="label" @click="focus" :class="{ 'required': required }">{{ label }}&nbsp;</label>
    </div>

    <template v-if="hasPermission || !disabled">
      <input class="text"
        :name="name"
        :type="type"
        :value="value"
        :disabled="disabled"
        :placeholder="placeholder"
        @input="update"
        @blur="$emit('blur')"
        ref="input"
      >
      <transition name="slide">
        <span v-if="error" class="block form-error text-xs">
          {{ error }}
        </span>
      </transition>
    </template>

    <div v-else class="readonly">
      <span v-if="value">{{ value }}</span>
      <span v-else>-</span>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['$validator'],
  props: {
    value: String,
    label: String,
    name: String,
    disabled: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    hasPermission: {
      type: Boolean,
      default: false
    },
    error: {
      type: String,
      required: false
    },
    type: {
      type: String,
      default: 'text',
      validator: val => {
        return (
          ['url', 'text', 'password', 'email', 'search'].indexOf(val) !== -1
        );
      }
    }
  },
  computed: {
    placeholder() {
      return `Voer een ${this.label.toLowerCase()} in`;
    }
  },
  methods: {
    update(event) {
      this.$emit('input', event.target.value);
    },
    focus() {
      this.$refs.input.focus();
    }
  }
};
</script>
